/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Download_PausedInputs */

const en_mobile_download_paused = /** @type {(inputs: Mobile_Download_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download paused`)
};

const es_mobile_download_paused = /** @type {(inputs: Mobile_Download_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarga en pausa`)
};

/**
* | output |
* | --- |
* | "Download paused" |
*
* @param {Mobile_Download_PausedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_download_paused = /** @type {((inputs?: Mobile_Download_PausedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Download_PausedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_download_paused(inputs)
	return en_mobile_download_paused(inputs)
});